<template>
    <v-container grid-list-lg style="max-width: 1260px" class="pb-5" :class="[precalc ? 'pt-0' : 'pt-5']">

        <v-layout :class="[precalc ? 'pt-0' : 'pt-5']"
                  v-if="companiesList.length"
        >
            <v-flex>
                <h2 class="pt-0 pb-4">Стоимость вашего ОСАГО с учетом скидок</h2>
                <h3 class="kbm-text pb-4" v-if="formIsChanged">Необходимо провести перерасчет полиса из-за измененных данных.</h3>
                <div class="color-wrapper" style="display: none;">
                    <span class="kbm-text mb-2" v-if="driversKbmText">{{ driversKbmText }}</span>
                    <v-flex v-if="showAlertWithoutDiscount">
                        <h3>Расчет произведен БЕЗ СКИДКИ за безаварийную езду. Возможно кто-то из водителей:</h3>
                        <ul>
                            <li>Менял права или получил новые после {{ getOneYearEarlierDate() }}</li>
                            <li>Был виновником ДТП</li>
                            <li>Или в данных водителей допущена ошибка. </li>
                        </ul>
                        <b>Исправьте сведения по водителям и пересчитайте стоимость.</b>
                    </v-flex>
                </div>
                <div class="color-wrapper" v-if="formattedKbm">
                    {{ formattedKbm }}
                </div>
            </v-flex>
        </v-layout>

        <v-layout
            key="key"
            v-show="!b2b && nobodyApproved && companiesList.length"
            align-center justify-start row wrap
            class="result"
        >
            <v-flex xs6 sm4 md2 pt4>
                <img src="/img/gp-logo.svg" class="logo hidden-xs-only"/>
                <img src="/img/gp-logo.svg" class="logo-sm hidden-sm-and-up"/>
            </v-flex>
            <v-flex xs6 sm8 md5 pt4>
                <v-layout align-center justify-start row wrap>
                    <p>Позвоните в службу поддержки, мы оформим полис для вас</p>
                </v-layout>
            </v-flex>
            <v-flex xs12 sm4 md3>
                <v-btn
                    class="payButton block tip-icon"
                    data-tippy-animateFill="false"
                    data-tippy-animation="scale"
                    data-tippy-content="Телефон: 8 800 201 06 43"
                    data-tippy-trigger="mouseenter click"
                >
                    Позвонить
                </v-btn>
            </v-flex>
        </v-layout>


        <transition-group name="results-list" tag="p">
            <v-layout
                v-for="(company, key) in sortedCompaniesList" :key="company.id"
                v-show="!(company.alias==='reso' && company.status==='error')"
                justify-start row wrap
                class="result"
            >
                <v-flex xs12 sm4 md3 pt4 class="result__logo-layout">
                    <img :src="company.image" class="logo hidden-xs-only"/>
                    <img :src="company.image" class="logo-sm hidden-sm-and-up"/>
                    <div class="hidden-sm-and-down blink-green" v-if="company.is_pull && company.status === 'ready'">
                        Полис передаётся в пул
                    </div>
                    <div class="hidden-sm-and-down blink-green" v-if="company.cross_calculated && company.status === 'ready'">
                        {{ 'ОСАГО + ' + company.cross_name  }}
                    </div>

                    <template v-if="company.informationBillet && company.status === 'ready'">
                        <div
                            v-if="company.informationBillet.changes && company.informationBillet.changes.enabled && company.informationBillet.changes.visibility"
                            class="information-billet__row"
                        >
                            <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                class="tip-icon"
                                :data-tippy-content="company.informationBillet.changes.tooltip || 'Доступно внесение изменений'"
                                data-tippy-animateFill="false"
                                data-tippy-animation="scale"
                            >
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.144"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <circle opacity="0.5" cx="12" cy="12" r="10" stroke="#00ba57" stroke-width="1.5"></circle>
                                    <path d="M12 17V11" stroke="#00ba57" stroke-width="1.5" stroke-linecap="round"></path>
                                    <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 9)" fill="#00ba57"></circle>
                                </g>
                            </svg>
                            <span class="information-billet__label">Внесём изменения</span>
                        </div>

                        <div
                            v-if="company.informationBillet.losses && company.informationBillet.losses.enabled && company.informationBillet.losses.visibility"
                            class="information-billet__row"
                        >
                            <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                class="tip-icon"
                                :data-tippy-content="company.informationBillet.losses.tooltip || 'Доступно урегулирование убытков'"
                                data-tippy-animateFill="false"
                                data-tippy-animation="scale"
                            >
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.144"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <circle opacity="0.5" cx="12" cy="12" r="10" stroke="#00ba57" stroke-width="1.5"></circle>
                                    <path d="M12 17V11" stroke="#00ba57" stroke-width="1.5" stroke-linecap="round"></path>
                                    <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 9)" fill="#00ba57"></circle>
                                </g>
                            </svg>
                            <span class="information-billet__label">Урегулируем убытки</span>
                        </div>
                    </template>
                </v-flex>

                <v-flex
                    xs12 sm8 hidden-md-and-up
                    v-if="company.status === 'ready' && (company.is_pull || company.cross_calculated)"
                    class="result__logo-layout"
                >
                    <div v-if="company.is_pull">
                        Полис передаётся в пул
                    </div>
                    <br>
                    <div v-if="company.cross_calculated">
                        {{ 'ОСАГО + ' + company.cross_name }}
                    </div>
                </v-flex>


                <v-flex xs9 sm12 md6 hidden-xs-only>
                    <v-layout v-if="!company.b2b"
                              align-center justify-start row wrap
                    >
                        <v-flex text-xs-center>
                            Срок действия
                            <img class="tip-icon" src="/svg/q.svg" alt=""
                                 data-tippy-animateFill="false"
                                 data-tippy-animation="scale"
                                 data-tippy-content="Срок действия полиса"
                            />
                            <br>
                            <span class="data-param">
                                {{ company.status==='ready' && company.payment.period ? company.payment.period : '-' }}
                            </span>
                        </v-flex>

                        <v-flex text-xs-center>
                            Базовый тариф
                            <img class="tip-icon" src="/svg/q.svg" alt=""
                                 data-tippy-animateFill="false"
                                 data-tippy-animation="scale"
                                 data-tippy-content="Величина базового тарифа выбирается страховой компанией из интервала, установленного Банком России https://www.cbr.ru/osago/"
                            />
                            <br>
                            <span class="data-param">
                                {{ company.status==='ready' && company.payment.base ? company.payment.base + " ₽" : '-' }}
                            </span>
                        </v-flex>

                        <v-flex text-xs-center>
                            КБМ
                            <img class="tip-icon" src="/svg/q.svg" alt=""
                                 data-tippy-animateFill="false"
                                 data-tippy-animation="scale"
                                 data-tippy-content="Это коэффициент, который понизит или повысит стоимость Вашего полиса в зависимости от аварийности вождения в прошлом. Точное значение КБМ вы узнаете после ввода данных о водителе и транспортном средстве"
                            />
                            <br>
                            <span class="data-param">
                                {{ company.status === 'ready' ?
                                    (company.payment.kbm ?
                                        company.payment.kbm :
                                        (defaultKbm ? defaultKbm : '-')
                                    ) :
                                '-' }}
                            </span>
                        </v-flex>
                    </v-layout>

                    <v-layout
                        v-else-if="newDesign"
                        align-center justify-start row wrap
                    >
                        <v-flex lg12>
                            <v-layout row wrap>
                                <v-flex xs4 lg4 xl4>
                                    <v-layout column wrap>
                                        <v-flex v-if="company.cross_calculated">
                                            <span class="data-title">Стоимость, ₽</span>
                                            <br>
                                            <span class="data-param">
                                                {{ company.status === 'ready' && company.payment.premium
                                                ? parseFloat(company.payment.premium).toFixed(2) + ' ₽'
                                                : '-' }}
                                            </span>
                                        </v-flex>
                                        <v-flex v-else-if="company.is_pull && !(company.alias === 'ingosstrah' && company.payment.commission_rub > 0)">
                                            <div v-show="!commissionsHidden"
                                               @click="toggleCommissions"
                                               class="color-black tip-icon width-auto"
                                               data-tippy-animateFill="false"
                                               data-tippy-animation="scale"
                                               data-tippy-content="Нажмите, чтобы скрыть вознаграждение"
                                            >
                                                <span class="data-title">Вознаграждение, %</span>
                                                <br>
                                                <span class="data-param">
                                                    -
                                                </span>
                                            </div>
                                        </v-flex>
                                        <v-flex v-else>
                                            <div v-show="!commissionsHidden"
                                               @click="toggleCommissions"
                                               class="color-black tip-icon width-auto"
                                               data-tippy-animateFill="false"
                                               data-tippy-animation="scale"
                                               data-tippy-content="Нажмите, чтобы скрыть вознаграждение"
                                            >
                                                <span class="data-title">Вознаграждение, %</span>
                                                <br>
                                                <span class="data-param">
                                                    {{ company.status==='ready' && company.payment.commission !== undefined
                                                    ? company.payment.commission
                                                    : '-' }}
                                                </span>
                                            </div>
                                        </v-flex>
                                        <v-flex
                                            class="cross-params"
                                            v-if="company.status === 'ready' && company.cross_calculated"
                                        >
                                            <v-layout row>
                                                <v-flex class="no-wrap">
                                                    <span class="data-cross-param" v-if="company.alias === 'sk-21-vek' && !company.payment.crossPremium">
                                                        {{ parseFloat(company.payment.premium - 1500).toFixed(2) + ' ₽'}}
                                                    </span>
                                                    <span class="data-cross-param" v-else>
                                                        {{ parseFloat(company.payment.premium - company.payment.crossPremium).toFixed(2) + ' ₽'}}
                                                    </span>
                                                    <div class="data-cross-title">ОСАГО</div>
                                                </v-flex>
                                                <v-flex class="no-wrap">
                                                    <span class="data-cross-param" v-if="company.alias === 'sk-21-vek' && !company.payment.crossPremium">
                                                        1500 ₽
                                                    </span>
                                                    <span class="data-cross-param" v-else>
                                                        {{ parseFloat(company.payment.crossPremium).toFixed(2) + ' ₽'}}
                                                    </span>
                                                    <div class="data-cross-title">{{ company.cross_name }}</div>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs4 lg4 xl4>
                                    <v-layout column wrap>
                                        <v-flex>
                                            <div v-show="!commissionsHidden"
                                               @click="toggleCommissions"
                                               class="color-black tip-icon width-auto"
                                               data-tippy-animateFill="false"
                                               data-tippy-animation="scale"
                                               data-tippy-content="Нажмите, чтобы скрыть вознаграждение"
                                            >
                                                <span class="data-title">Вознаграждение, ₽</span>
                                                <br>
                                                <span class="data-param" v-if="company.status === 'ready' && company.premium_spread">
                                                    {{ company._tariffOpen ? getCommissionRubFromSlider(company) : commissionGetter(company) }}
                                                </span>
                                                <span class="data-param" v-else>
                                                    {{ commissionGetter(company) }}
                                                </span>
                                            </div>
                                        </v-flex>
                                            <div v-show="commissionsHidden"
                                               @click="toggleCommissions"
                                               class="color-black"
                                            >
                                                <v-flex text-xs-center>
                                                    Вернуть
                                                </v-flex>
                                            </div>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs4 lg4 xl4>
                                    <span class="data-title">Срок действия</span>
                                    <img class="tip-icon" src="/svg/q.svg" alt=""
                                         data-tippy-animateFill="false"
                                         data-tippy-animation="scale"
                                         data-tippy-content="Срок действия полиса"
                                    />
                                    <br>
                                    <span class="data-param">
                                        {{ company.status==='ready' && company.payment.period ? company.payment.period : '-' }}
                                    </span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex lg12>
                            <v-layout row wrap>
                                <template v-if="company.status === 'ready'">
                                    <v-flex shrink>
                                        <span class="data-title">Базовый тариф</span>
                                        <img class="tip-icon" src="/svg/q.svg" alt=""
                                             data-tippy-animateFill="false"
                                             data-tippy-animation="scale"
                                             data-tippy-content="Величина базового тарифа выбирается страховой компанией из интервала, установленного Банком России https://www.cbr.ru/osago/"
                                        />
                                        <br>
                                        <span class="data-param" v-if="company.status === 'ready' && company.premium_spread">
                                            {{ company._tariffOpen ? getBaseTariffFromSlider(company) : Math.floor(company.payment.base) }}
                                        </span>
                                        <span class="data-param" v-else>
                                            {{ company.status==='ready' && company.payment.base ? company.payment.base + " ₽" : '-' }}
                                        </span>
                                    </v-flex>

                                    <v-flex
                                        v-if="coefficients && coefficients.kt"
                                        shrink
                                    >
                                        <span class="data-title">КТ</span>
                                        <br>
                                        <span class="data-param">
                                            {{ coefficients.kt }}
                                        </span>
                                    </v-flex>

                                    <v-flex shrink>
                                        <span class="data-title">КБМ</span>
                                        <img class="tip-icon" src="/svg/q.svg" alt=""
                                             data-tippy-animateFill="false"
                                             data-tippy-animation="scale"
                                             data-tippy-content="Это коэффициент, который понизит или повысит стоимость Вашего полиса в зависимости от аварийности вождения в прошлом. Точное значение КБМ вы узнаете после ввода данных о водителе и транспортном средстве"
                                        />
                                        <br>
                                        <span class="data-param">
                                            {{ company.status === 'ready' ?
                                            (company.payment.kbm ?
                                                    company.payment.kbm :
                                                    (defaultKbm ? defaultKbm : '-')
                                            ) :
                                            '-' }}
                                        </span>
                                    </v-flex>

                                    <v-flex
                                        v-if="coefficients && coefficients.kvs"
                                        shrink
                                    >
                                        <span class="data-title">КВС</span>
                                        <br>
                                        <span class="data-param">
                                            {{ coefficients.kvs }}
                                        </span>
                                    </v-flex>

                                    <v-flex
                                        v-if="coefficients && coefficients.ko"
                                        shrink
                                    >
                                        <span class="data-title">КО</span>
                                        <br>
                                        <span class="data-param">
                                            {{ coefficients.ko }}
                                        </span>
                                    </v-flex>

                                    <v-flex
                                        v-if="coefficients && coefficients.ks"
                                        shrink
                                    >
                                        <span class="data-title">КС</span>
                                        <br>
                                        <span class="data-param">
                                            {{ coefficients.ks }}
                                        </span>
                                    </v-flex>

                                    <v-flex
                                        v-if="coefficients && coefficients.km"
                                        shrink
                                    >
                                        <span class="data-title">КМ</span>
                                        <br>
                                        <span class="data-param">
                                            {{ coefficients.km }}
                                        </span>
                                    </v-flex>
                                </template>
                            </v-layout>
                        </v-flex>
                        <v-flex
                            v-if="(waitFetchCross && company.status !== 'error') || company.status === 'waiting'"
                            row wrap lg12
                        >
                            <a class="show-cross-btn" @click="showMore(company)">Кросс предложения</a>
                            <v-icon class="material-symbols-outlined arrow-up-down" :class='{ "rotate": company.showCross }'>
                                expand_more
                            </v-icon>
                        </v-flex>
                        <v-flex
                            v-else-if="company.crosses && Object.keys(company.crosses).length > 0 && !waitFetchCross && company.status !== 'error' && (company.alias !== 'sk-21-vek' || !company.is_pull)"
                            row wrap lg12
                        >
                            <a class="show-cross-btn" @click="showMore(company)">Кросс предложения</a>
                            <v-icon class="material-symbols-outlined arrow-up-down" :class='{ "rotate": company.showCross }'>
                                expand_more
                            </v-icon>
                        </v-flex>
                    </v-layout>

                    <v-layout v-else
                              align-center justify-start row wrap
                    >
                        <v-flex xs4 text-xs-center>
                            Срок действия
                            <img class="tip-icon" src="/svg/q.svg" alt=""
                                 data-tippy-animateFill="false"
                                 data-tippy-animation="scale"
                                 data-tippy-content="Срок действия полиса"
                            />
                            <br>
                            <span class="data-param">
                                {{ company.status==='ready' && company.payment.period ? company.payment.period : '-' }}
                            </span>
                        </v-flex>

                        <a v-show="!commissionsHidden"
                           @click="toggleCommissions"
                           class="color-black tip-icon width-auto"
                           data-tippy-animateFill="false"
                           data-tippy-animation="scale"
                           data-tippy-content="Нажмите, чтобы скрыть вознаграждение"
                        >
                            <v-flex text-xs-center v-if="company.is_pull">
                                <span class="blink-green">Пул Кросс, ₽</span>
                                <br>
                                <span class="data-param">
                                    -
                                </span>
                            </v-flex>
                            <v-flex text-xs-center v-else>
                                Вознаграждение, %
                                <br>
                                <span class="data-param">
                                    {{ company.status==='ready' && company.payment.commission !== undefined
                                    ? company.payment.commission
                                    : '-' }}
                                </span>
                            </v-flex>
                        </a>
                        <a v-show="!commissionsHidden"
                           @click="toggleCommissions"
                           class="color-black tip-icon width-auto"
                           data-tippy-animateFill="false"
                           data-tippy-animation="scale"
                           data-tippy-content="Нажмите, чтобы скрыть вознаграждение"
                        >
                            <v-flex text-xs-center>
                                Вознаграждение, ₽
                                <br>
                                <span class="data-param" v-if="company.is_pull && (company.alias === 'alpha' || company.alias === 'rosgosstrah' || company.alias === 'soglasie') && company.payment && company.payment.commission_rub">
                                    {{ company.payment.commission_rub + ' ₽' }}
                                </span>
                                <span class="data-param" v-else-if="company.is_pull">
                                    -
                                </span>
                                <span class="data-param" v-else>
                                {{ company.status==='ready' && company.payment.commission_rub !== undefined
                                    ? company.payment.commission_rub + ' ₽'
                                    : '-' }}
                                </span>
                            </v-flex>
                        </a>
                        <a v-show="commissionsHidden"
                           @click="toggleCommissions"
                           class="color-black"
                           style="align-self: flex-start;"
                        >
                            <v-flex>
                                Вернуть
                            </v-flex>
                        </a>

                        <template v-if="company.status === 'ready'">
                            <v-flex text-xs-center>
                                Базовый тариф
                                <img class="tip-icon" src="/svg/q.svg" alt=""
                                     data-tippy-animateFill="false"
                                     data-tippy-animation="scale"
                                     data-tippy-content="Величина базового тарифа выбирается страховой компанией из интервала, установленного Банком России https://www.cbr.ru/osago/"
                                />
                                <br>
                                <span class="data-param">
                                    {{ company.status==='ready' && company.payment.base ? company.payment.base + " ₽" : '-' }}
                                </span>
                            </v-flex>

                            <v-flex v-if="coefficients && coefficients.kt" text-xs-center>
                                КТ
                                <br>
                                <span class="data-param">
                                    {{coefficients.kt}}
                                </span>
                            </v-flex>

                            <v-flex text-xs-center>
                                КБМ
                                <img class="tip-icon" src="/svg/q.svg" alt=""
                                     data-tippy-animateFill="false"
                                     data-tippy-animation="scale"
                                     data-tippy-content="Это коэффициент, который понизит или повысит стоимость Вашего полиса в зависимости от аварийности вождения в прошлом. Точное значение КБМ вы узнаете после ввода данных о водителе и транспортном средстве"
                                />
                                <br>
                                <span class="data-param">
                                    {{ company.status === 'ready' ?
                                    (company.payment.kbm ?
                                            company.payment.kbm :
                                            (defaultKbm ? defaultKbm : '-')
                                    ) :
                                    '-' }}
                                </span>
                            </v-flex>

                            <v-flex v-if="coefficients && coefficients.kvs" text-xs-center>
                                КВС
                                <br>
                                <span class="data-param">
                                    {{coefficients.kvs}}
                                </span>
                            </v-flex>

                            <v-flex v-if="coefficients && coefficients.ko" text-xs-center>
                                КО
                                <br>
                                <span class="data-param">
                                    {{coefficients.ko}}
                                </span>
                            </v-flex>

                            <v-flex v-if="coefficients && coefficients.ks" text-xs-center>
                                КС
                                <br>
                                <span class="data-param">
                                    {{coefficients.ks}}
                                </span>
                            </v-flex>

                            <v-flex v-if="coefficients && coefficients.km" text-xs-center>
                                КМ
                                <br>
                                <span class="data-param">
                                    {{coefficients.km}}
                                </span>
                            </v-flex>
                        </template>
                    </v-layout>
                </v-flex>

                <v-flex xs12 sm6 md3 align-center v-if="formIsChanged">
                    <v-btn class="payButton block" disabled>
                        Проведите перерасчет
                    </v-btn>
                </v-flex>

                <v-flex xs12 sm6 md3 align-center justify-center v-else class="button-wrapper">
                    <a v-if="company.status==='waiting'" class="payButtonLink block" disabled="disabled">
                        Рассчитывается
                        <div class="loader-wrapper">
                            <img class="btn-loading" src="/img/button-loader.gif">
                        </div>
                    </a>
                    <a v-if="company.status==='ready' && company.cross_double_pay && orderStatus !== 'success' && !company._tariffOpen"
                       class="policy underline above-button text-center"
                       @click="testBuyCross(company)"
                    >
                        Оплатить по ссылке
                    </a>
                    <a v-else-if="company.status==='ready' && orderStatus !== 'success' && !company._tariffOpen"
                       class="policy underline above-button text-center"
                       :href="company.payment.manageLink"
                    >
                        Оплатить по ссылке
                    </a>
                    <p v-else-if="company.status === 'ready' && orderStatus !== 'success' && company._tariffOpen"
                       class="policy underline above-button text-center disabled-link mb-0"
                    >
                        Оплатить по ссылке
                    </p>
                    <v-btn
                        v-if="company.status === 'ready' && orderStatus === 'success' && successProcessing.companyId === company.id"
                        class="payButton block"
                    >
                        Оформлен за {{ parseFloat(successProcessing.premium).toFixed(2) }} ₽
                    </v-btn>
                    <v-btn
                        v-else-if="company.status === 'ready' && orderStatus === 'success' && successProcessing.companyId !== company.id"
                        class="payButton block"
                    >
                        {{ parseFloat(company.payment.premium).toFixed(2) }} ₽
                    </v-btn>
                    <v-btn
                        v-else-if="company.status === 'ready' && company.crosses && Object.keys(company.crosses).length > 0 && !waitFetchCross && company.status !== 'error'"
                        @click="company.cross_double_pay ? testBuyCross(company) : buy(company)"
                        class="payButton block tip-button"
                        :loading="!!company.payment.wait"
                        :disabled="company._tariffOpen"
                        :id="company.alias + '_osago'"
                        data-tippy-animateFill="false"
                        data-tippy-animation="scale"
                        data-tippy-content="
                            <span class='tippy-title'>Ваш доход +250–3 000 ₽ с кросс-продаж.</span><br><span>Оформите МиниКАСКО / НС — в один клик, предложения сразу под расчётом ОСАГО.</span>"
                        >
                            {{ company.precalc ? 'Продолжить' : 'Оформить' }} за {{ parseFloat(company.payment.premium).toFixed(2) }} ₽
                        <span v-if="company.premium_spread" slot="loader" class="v-progress-circular--indeterminate payButton-loader">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="21.904761904761905 21.904761904761905 43.80952380952381 43.80952380952381" style="transform: rotate(0deg);"><circle fill="transparent" cx="43.80952380952381" cy="43.80952380952381" r="20" stroke-width="3.8095238095238093" stroke-dasharray="125.664" stroke-dashoffset="125.66370614359172px" class="v-progress-circular__overlay"></circle></svg>
                        </span>
                        <span v-else slot="loader" class="v-progress-circular--indeterminate payButton-loader">
                            <span v-if="company.alias == 'astro-volga' || company.alias == 'sk-21-vek' || company.alias == 'absolute'">Ждите ссылку</span>
                            <div v-if="company.alias == 'astro-volga' || company.alias == 'absolute'" class="timer" v-html="timerText"></div>
                            <div v-else-if="company.alias == 'sk-21-vek'" class="timer" v-html="timerText21Vek"></div>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="21.904761904761905 21.904761904761905 43.80952380952381 43.80952380952381" style="transform: rotate(0deg);"><circle fill="transparent" cx="43.80952380952381" cy="43.80952380952381" r="20" stroke-width="3.8095238095238093" stroke-dasharray="125.664" stroke-dashoffset="125.66370614359172px" class="v-progress-circular__overlay"></circle></svg>
                        </span>
                    </v-btn>
                    <v-btn
                        v-else-if="company.status === 'ready'"
                        @click="company.cross_double_pay ? testBuyCross(company) : buy(company)"
                        class="payButton block"
                        :loading="!!company.payment.wait"
                        :disabled="company._tariffOpen"
                        :id="company.alias + '_osago'"
                    >
                        {{ company.precalc ? 'Продолжить' : 'Оформить' }} за {{ parseFloat(company.payment.premium).toFixed(2) }} ₽
                        <span v-if="company.premium_spread" slot="loader" class="v-progress-circular--indeterminate payButton-loader">
                            <span v-if="company.alias == 'astro-volga' || company.alias == 'sk-21-vek' || company.alias == 'absolute'">Ждите ссылку</span>
                            <div v-if="company.alias == 'astro-volga' || company.alias == 'absolute'" class="timer" v-html="timerText"></div>
                            <div v-else-if="company.alias == 'sk-21-vek'" class="timer" v-html="timerText21Vek"></div>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="21.904761904761905 21.904761904761905 43.80952380952381 43.80952380952381" style="transform: rotate(0deg);"><circle fill="transparent" cx="43.80952380952381" cy="43.80952380952381" r="20" stroke-width="3.8095238095238093" stroke-dasharray="125.664" stroke-dashoffset="125.66370614359172px" class="v-progress-circular__overlay"></circle></svg>
                        </span>
                        <span v-else slot="loader" class="v-progress-circular--indeterminate payButton-loader">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="21.904761904761905 21.904761904761905 43.80952380952381 43.80952380952381" style="transform: rotate(0deg);"><circle fill="transparent" cx="43.80952380952381" cy="43.80952380952381" r="20" stroke-width="3.8095238095238093" stroke-dasharray="125.664" stroke-dashoffset="125.66370614359172px" class="v-progress-circular__overlay"></circle></svg>
                        </span>
                    </v-btn>

                    <div class="tariff-change-wrapper">
                        <span
                            v-if="company.status === 'ready' && company.premium_spread && parseFloat(company.premium_spread.premium_max) > parseFloat(company.premium_spread.premium_min) && !company.is_pull"
                            :key="`premium-spread-${company.id}-${company._isOpenedPayment}-${orderStatus}`"
                            :id="`premium-spread-feature-${company.id}`"
                            class="tip-button"
                            data-tippy-animateFill="false"
                            data-tippy-animation="scale"
                            :data-tippy-content="company._isOpenedPayment || orderStatus === 'success' || company.contract_status === '300'
                                ? 'Повторное изменение цены возможно только при пересчёте ордера'
                                : 'Измените цену с помощью «бегунка» и увеличьте своё вознаграждение'"
                        >
                            <button
                                @click="toggleTariffPanel(company)"
                                class="tariff-change-button"
                                id="premium-spread-feature"
                                :disabled="company._isOpenedPayment || orderStatus === 'success' || company.contract_status === '300'"
                            >
                                <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11 2l3 3-8 8H3v-3L11 2z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                                Снизить / повысить цену
                            </button>
                        </span>

                        <div v-if="company._tariffOpen" class="tariff-panel" :id="`tariff-panel-${company.id}`">
                            <p class="tariff-panel__title">Выберите сумму премии</p>

                            <div class="tariff-panel__values">
                                <input
                                    type="number"
                                    class="tariff-panel__manual-input"
                                    :style="{ color: getTariffColor(company) }"
                                    :value="parseFloat(company._tariffSlider).toFixed(2)"
                                    :min="parseFloat(company.premium_spread.premium_min)"
                                    :max="parseFloat(company.premium_spread.premium_max)"
                                    @change="onManualPremiumInput(company, $event)"
                                />
                                <span class="tariff-panel__currency">₽</span>
                            </div>

                            <input
                                type="range"
                                :min="parseFloat(company.premium_spread.premium_min)"
                                :max="parseFloat(company.premium_spread.premium_max)"
                                step="1"
                                :value="company._tariffSlider"
                                :style="{
                                background: `linear-gradient(to right, #00BA57 ${getTariffProgress(company) * 100}%, #e0e0e0 0%)`
                            }"
                                @input="$set(company, '_tariffSlider', parseFloat($event.target.value))"
                            />

                            <div class="tariff-panel__labels">
                                <span>{{ parseFloat(company.premium_spread.premium_min).toFixed(2) }} ₽</span>
                                <span>{{ parseFloat(company.premium_spread.premium_max).toFixed(2) }} ₽</span>
                            </div>

                            <button
                                :disabled="!(company._tariffSlider !== parseFloat(company.payment.premium))"
                                class="tariff-recalc-btn"
                                @click="recalculate(company)"
                            >
                                Применить
                            </button>
                            <button
                                class="tariff-recalc-btn reject"
                                @click="company._tariffOpen = false"
                            >
                                Отменить
                            </button>
                        </div>
                    </div>

                    <span style="display: block; padding: 10px 22px 0; text-align: center; color: #00BA57"
                          class="start-action-text"
                          :class="(dateStart && company.payment.start_date_value !== dateStart) ? 'blink-green' : ''"
                          v-if="company.status==='ready' && company.payment.start_date">
                        Начало действия - <span class="start-date-text">{{ company.payment.start_date }}</span>
                    </span>
                    <span
                        style="display: block; padding: 10px 22px 0; text-align: center; color: #00BA57"
                        class="blink-green payment-hint"
                        v-if="company.status === 'ready' && (company.alias === 'gelios' || company.alias === 'borovitskoe')"
                    >
                        Проверьте возможность оплаты перед озвучиванием предложения клиенту
                    </span>

                    <div v-if="company.status==='error'">
                        <strong class="wrong-label">Не подтверждено</strong>

                        <img v-if="company.error_text"
                             class="tip-icon" src="/svg/q_red.svg" alt=""
                             data-tippy-animateFill="false"
                             data-tippy-animation="scale"
                             data-tippy-theme="red"
                             :data-tippy-content="company.error_text"
                        />
                        <img v-if="!company.error_text"
                             class="tip-icon" src="/svg/q.svg" alt=""
                             data-tippy-animateFill="false"
                             data-tippy-animation="scale"
                             data-tippy-content="Причиной может быть возраст или стаж водителя. Кроме того у компаний есть квота на регион."
                        />
                    </div>
                </v-flex>

                <v-flex
                    lg12
                    v-model="company.showCross"
                    v-if="canShowCross(company)"
                >
                    <osago-companies-list-cross
                        :data="company"
                        :parentKey="company.id"
                        :panel="company.panel"
                        :crosses="company.crosses"
                        :selectedCrossId="company.selectedCrossId"
                        :commissionsHidden="commissionsHidden"
                        :crossCommissionsHidden="crossCommissionsHidden"
                        :updatedAt="company.payment && company.payment.updated_at"
                        :orderStatus="orderStatus"
                        :waitFetchCross="waitFetchCross"
                        @selectCrossId="selectCrossId"
                        @crossSaleClick="crossSaleClick(company)"
                        @hideCrossCommissions="toggleCrossCommissions"
                    ></osago-companies-list-cross>
                </v-flex>
            </v-layout>
        </transition-group>

    </v-container>
</template>

<script>
    import _ from 'lodash';
    import ymMixin from '../mixins/ym';

    export default {
        name: 'CompaniesList',
        props: [
            'companiesList',
            'precalc',
            'b2b',
            'defaultCompany',
            'allowApproveMetrika',
            'coefficients',
            'dateStart',
            'formIsChanged',
            'orderStatus',
            'newDesign',
            'successProcessing',
            'showAlertWithoutDiscount',
            'waitFetchCross',
            'uuid',
        ],
        mixins: [ymMixin],


        data: () => ({
            sortedCompaniesList: null,
            driversKbmText: null,
            driversKbms: null,
            paymentLoading: false,
            showContactCurator: false,
            oneYearEarlier: null,
            nobodyApproved: false,
            metrikaFlag: true,
            defaultKbm: null,
            commissionsHidden: false,
            waitInterval: null,
            timerValue: 210,
            timerValue21Vek: 300,
            timerText: '3:30',
            timerText21Vek: '5:00',
            crossSelected: null,
            crossCommissionsHidden: false,
        }),

        updated: () => {
            window.tippy.default('.tip-icon');
            setTimeout(() => {
                window.tippy.default('.tip-button', {
                    theme: 'light',
                    placement: 'bottom',
                });
            }, 0);
        },

        created() {
            for (let i = 0; i < this.companiesList.length; i++) {
                Vue.set(this.companiesList[i], 'showCross', true)
            }

            if (this.companiesList) {
                this.companiesList.forEach((item) => {
                    item.panel = ['0']
                })
            }
        },
        watch: {
            companiesList: {
                deep: true,
                immediate: true,
                handler: function (val) {
                    const clonedCompaniesList = Array.isArray(val) ? val.slice() : [];
                    this.sortedCompaniesList = _.orderBy(
                        clonedCompaniesList,
                        [
                            function (o) {
                                return (o.alias && o.alias.toLowerCase() === 'sk-21-vek' && o.status === 'ready') ? 0 : 1;
                            },
                            function (o) {
                                return o.status === 'ready' ? 0 : o.status === 'waiting' ? 1 : 2;
                            },
                            function (o) {
                                return (o.payment && o.payment.premium > 0) ? Number(o.payment.premium) : 1000000;
                            },
                            function (o) {
                                return o.name ? o.name.toLowerCase() : '';
                            }
                        ],
                        ['asc', 'asc', 'asc']
                    );

                    let that = this;
                    let showContactCurator = true;
                    let countError = 0;
                    let success = false;
                    let premiumSpreadFound = false; // флаг, чтобы найти первое вхождение и остановиться

                    _.forEach(this.companiesList, function (company) {
                        if (company.selectedCrossId === undefined) Vue.set(company, 'selectedCrossId', null)
                        if (company.selectedCross === undefined) Vue.set(company, 'selectedCross', null)
                        if (company.selectedCategory === undefined) Vue.set(company, 'selectedCategory', null)
                        if (company._isOpenedPayment === undefined) Vue.set(company, '_isOpenedPayment', false);
                        if (company.status !== 'error') {
                            showContactCurator = false;
                        }
                        if (company.kbms_text) {
                            that.driversKbmText = company.kbms_text;
                        }
                        if (company.kbms) {
                            if (typeof company.kbms === 'string') {
                                try {
                                    that.driversKbms = JSON.parse(company.kbms);
                                } catch (e) {
                                    console.error('Ошибка парсинга JSON:', e);
                                }
                            } else if (typeof company.kbms === 'object') {
                                that.driversKbms = company.kbms;
                            } else {
                                console.error('Неожиданный формат ответа:', company.kbms);
                            }
                            that.$emit('handleDriversKbms', that.driversKbms);
                        }
                        if (company.status == 'error') {
                            countError++;
                        }
                        if (company.status == 'ready') {
                            if (that.defaultKbm === null && company.payment.kbm) {
                                that.defaultKbm = company.payment.kbm;
                            }
                            success = true;
                        }

                        // Ищем первый непустой premium_spread
                        if (
                            !premiumSpreadFound &&
                            company.premium_spread &&
                            typeof company.premium_spread === 'object' &&
                            Object.keys(company.premium_spread).length > 0
                        ) {
                            premiumSpreadFound = true;
                        }
                    });

                    // Запускаем тур, если нашли premium_spread и ещё не показывали
                    if (premiumSpreadFound && !localStorage.getItem('premiumSpreadTourShown')) {
                        this.$nextTick(() => {
                            this.startTour();
                            localStorage.setItem('premiumSpreadTourShown', '1');
                        });
                    }

                    if (countError == this.companiesList.length) {
                        this.nobodyApproved = true
                        if (this.allowApproveMetrika && this.metrikaFlag) {
                            this.reachGoal('osago_not_approved')
                            this.metrikaFlag = false
                        }
                    } else {
                        this.nobodyApproved = false
                    }
                    if (this.allowApproveMetrika && success && this.metrikaFlag) {
                        this.reachGoal('osago_approved')
                        this.metrikaFlag = false
                    }
                    this.showContactCurator = showContactCurator && this.companiesList.length;
                }
            }
        },

        methods: {
            startTour() {
                const driver = window.driver.js.driver;

                const driverObj = driver({
                    popoverClass: 'driverjs-theme',
                    showButtons: ['close'],
                });

                driverObj.highlight({
                    element: "#premium-spread-feature",
                    popoverClass: 'driverjs-theme',
                    showButtons: ['close'],
                    popover: {
                        title: "Обновление",
                        description: "Измените цену с помощью «бегунка» и увеличьте своё вознаграждение." +
                            "<br>*Функция «Изменить цену» доступна, только если СК это позволяет."
                    }
                });
            },
            recalculate(company) {
                company.payment.wait = true;
                const data = {
                    'alias': company.alias,
                    'updatedPremium': parseFloat(company._tariffSlider),
                    'updatedBase': parseFloat(company._baseTariffSlider),
                    'updatedCommissionRub': parseFloat(company._commissionRubTariffSlider),
                };
                axios.post('/changePriceSpread', data)
                    .then(response => {
                        if (response.data && response.data.status) {
                            if (response.data.status === 'ok') {
                                company.payment.base = parseFloat(company._baseTariffSlider);
                                company.payment.premium = parseFloat(company._tariffSlider).toFixed(2);
                                company.payment.commission_rub = parseFloat(company._commissionRubTariffSlider);
                            }
                        }
                    })
                    .catch(error => {
                        if (error && error.message) {
                            PNotify.error(error.message);
                            this.$set(company, 'status', 'error');
                            this.$set(company, 'error_text', error.message);
                        }
                    })
                    .finally(() => {
                        this.$set(company, '_tariffOpen', false);
                        company.payment.wait = false;
                    });
            },

            getSpreadCoefficients(company) {
                if (!company.premium_spread || !company.premium_spread.coefficients) return null;
                return company.premium_spread.coefficients.reduce((acc, item) => {
                    acc[item.name] = parseFloat(item.value);
                    return acc;
                }, {});
            },

            // Произведение всех коэффициентов КРОМЕ tb
            getCoeffProduct(company) {
                const coefs = this.getSpreadCoefficients(company);
                if (!coefs) return 1;
                return Object.entries(coefs)
                    .filter(([name]) => name !== 'tb')
                    .reduce((acc, [, value]) => acc * value, 1);
            },

            // Вычисляем базовый тариф из текущего значения слайдера
            // tb = premium / (все коеф кроме tb)
            getBaseTariffFromSlider(company) {
                if (!company._tariffSlider || !company.premium_spread) return '-';
                const coeffProduct = this.getCoeffProduct(company);
                if (!coeffProduct) return '-';
                const value = (parseFloat(company._tariffSlider) / coeffProduct).toFixed(2)
                company._baseTariffSlider = value;
                return Math.floor(value);
            },

            getCommissionRubFromSlider(company) {
                if (!company._tariffSlider) return '-';

                const premium = parseFloat(company._tariffSlider);
                const commissionStr = company.payment && company.payment.commission;

                if (!commissionStr) return '-';

                // Парсим процент из строки вида "12%" или "0%"
                const percent = parseFloat(commissionStr.replace('%', ''));

                if (isNaN(percent) || percent === 0) return '-';

                const value = ((premium * percent / 100).toFixed(2));

                company._commissionRubTariffSlider = value;

                return Math.round(value) + ' ₽';
            },

            // Прогресс для градиента слайдера
            getTariffProgress(company) {
                if (!company.premium_spread) return 0;
                const min = parseFloat(company.premium_spread.premium_min);
                const max = parseFloat(company.premium_spread.premium_max);
                const val = parseFloat(company._tariffSlider) || min;
                return (val - min) / (max - min);
            },

            // Открытие/закрытие панели, инициализация слайдера текущим значением
            toggleTariffPanel(company) {
                if (!company._tariffOpen) {
                    this.$set(company, '_tariffSlider', parseFloat(company.payment.premium));
                    this.$set(company, '_baseTariffSlider', parseFloat(company.payment.base));
                    this.$set(company, '_commissionRubTariffSlider', parseFloat(company.payment.commission_rub));
                    this.$set(company, '_tariffOpen', true);
                }
            },

            // Обработка ручного ввода: клампим значение в допустимый диапазон
            onManualPremiumInput(company, event) {
                const min = parseFloat(company.premium_spread.premium_min);
                const max = parseFloat(company.premium_spread.premium_max);
                let val = parseFloat(event.target.value);

                if (isNaN(val)) val = min;
                val = Math.min(Math.max(val, min), max);

                this.$set(company, '_tariffSlider', val);

                // Корректируем значение инпута если было введено вне диапазона
                event.target.value = val.toFixed(2);
            },

            getTariffColor(company) {
                if (!company.premium_spread || !company._tariffSlider) return '#00BA57';
                const min = parseFloat(company.premium_spread.premium_min);
                const max = parseFloat(company.premium_spread.premium_max);
                const val = parseFloat(company._tariffSlider);

                // red #E53535 to green #00BA57
                if (!isFinite(min) || !isFinite(max) || max === min) return '#00BA57';

                const t = Math.max(0, Math.min(1, (val - min) / (max - min)));
                const r = Math.round(229 + (0 - 229) * t);
                const g = Math.round(53 + (186 - 53) * t);
                const b = Math.round(53 + (87 - 53) * t);

                return `rgb(${r},${g},${b})`;
            },

            getOneYearEarlierDate: function() {
                let date = new Date()
                date.setFullYear(date.getFullYear() - 1)
                return date.toLocaleString("ru", {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    timezone: 'UTC'
                })
            },

            buy: function (company) {
                if (this.paymentLoading) return;

                this.paymentLoading = true;

                if (company.precalc) {
                    this.reachGoal('preCalcOrder');
                    this.reachGoal('step1_click');
                    // нам не нужно валидировать оплату здесь,
                    // потому что из формы предрасчета человек просто переводится на форму длинной заявки
                    window.location.replace(company.payment.url);
                } else {
                    this.reachGoal('step2_click');
                    if(this.b2b){
                        this.reachGoal('calcPay-B2B', {
                            order_price: company.payment.premium,
                            currency: "RUB"
                        });
                    } else {
                        this.reachGoal('calcPay', {
                            order_price: company.payment.premium,
                            currency: "RUB"
                        });
                    }
                    if (typeof ym === 'function') {
                        ym(100170943, 'reachGoal', 'sale_click_btn', {
                            order_price: company.payment.premium,
                            currency: 'RUB',
                        });
                    }
                    this.startWait(company);
                    this.$set(company, '_isOpenedPayment', true);
                    let that = this;
                    axios.get(company.payment.validateUrl).then(() => {
                        const paymentWindow = window.open(company.payment.url, '_blank');
                        const timer = setInterval(function() {
                            if (paymentWindow && paymentWindow.closed) {
                                clearInterval(timer);
                                that.paymentLoading = false;
                            }
                        }, 1000);
                    }).catch(error => {
                        console.log(error.response);
                        this.paymentLoading = false;
                        company.status = 'error';
                        if (error.response && error.response.data.message) {
                            company.error_text = error.response.data.message;
                            PNotify.error(company.name + ":\n" + error.response.data.message);
                        }
                    }).finally(() => {
                        this.stopWait(company)
                    });
                }
            },
            buyCross(company) {
                window.open(company.payment.manageCrossLink, '_self');
            },
            testBuyCross(company) {
                if (this.paymentLoading) return;

                this.paymentLoading = true;

                if (company.precalc) {
                    this.reachGoal('preCalcOrder');
                    this.reachGoal('step1_click');
                    // нам не нужно валидировать оплату здесь,
                    // потому что из формы предрасчета человек просто переводится на форму длинной заявки
                    window.location.replace(company.payment.url);
                } else {
                    this.reachGoal('step2_click');
                    if(this.b2b){
                        this.reachGoal('calcPay-B2B', {
                            order_price: company.payment.premium,
                            currency: "RUB"
                        });
                    } else {
                        this.reachGoal('calcPay', {
                            order_price: company.payment.premium,
                            currency: "RUB"
                        });
                    }
                    if (typeof ym === 'function') {
                        ym(100170943, 'reachGoal', 'sale_click_btn', {
                            order_price: company.payment.premium,
                            currency: 'RUB',
                        });
                    }
                    this.startWait(company)
                    this.$set(company, '_isOpenedPayment', true);
                    let that = this;
                    axios.get(company.payment.getErrorManageCrossLink, {
                        params: {
                            selectedCrossId: company.selectedCrossId,
                        }
                    }).then(() => {
                        let paymentUrl = `${company.payment.manageCrossLink}`;

                        if (company.selectedCrossId) {
                            paymentUrl += `?selectedCrossId=${company.selectedCrossId}`;
                        }

                        const paymentWindow = window.open(paymentUrl, '_blank');

                        const timer = setInterval(function() {
                            if (paymentWindow && paymentWindow.closed) {
                                clearInterval(timer);
                                that.paymentLoading = false;
                            }
                        }, 1000);
                    }).catch(error => {
                        console.log(error.response);
                        this.paymentLoading = false;
                        company.status = 'error';
                        if (error.response && error.response.data.message) {
                            company.error_text = error.response.data.message;
                            PNotify.error(company.name + ":\n" + error.response.data.message);
                        }
                    }).finally(() => {
                        this.stopWait(company)
                    });
                }
            },
            startWait(company) {
                company.payment.wait = true
                if(company.alias == 'astro-volga' || company.alias == 'sk-21-vek' || company.alias == 'absolute') {
                    this.waitInterval = setInterval(() => {
                        if (company.alias == 'sk-21-vek') {
                            if(!this.timerValue21Vek) {
                                clearInterval(this.waitInterval)
                                return
                            }
                            this.timerValue21Vek --
                            this.changeTimerText21Vek(this.timerValue21Vek)
                        } else {
                            if(!this.timerValue) {
                                clearInterval(this.waitInterval)
                                return
                            }
                            this.timerValue --
                            this.changeTimerText(this.timerValue)
                        }
                    }, 1000)
                }
            },

            stopWait(company) {
                company.payment.wait = false
                if(company.alias == 'astro-volga' || company.alias == 'sk-21-vek' || company.alias == 'absolute') {
                    clearInterval(this.waitInterval)
                }
            },

            changeTimerText(value) {
                let minutes = Math.floor(value / 60);
                let seconds = value % 60;
                this.timerText = [
                    minutes,
                    seconds.toString().padStart(2, '0')
                ].join(':');
            },

            changeTimerText21Vek(value) {
                let minutes = Math.floor(value / 60);
                let seconds = value % 60;
                this.timerText21Vek = [
                    minutes,
                    seconds.toString().padStart(2, '0')
                ].join(':');
            },

            toggleCommissions() {
                this.commissionsHidden = !this.commissionsHidden;
            },

            toggleCrossCommissions() {
                this.crossCommissionsHidden = !this.crossCommissionsHidden;
            },

            showMore(company) {
                company.showCross = !company.showCross
                if (!company.panel.length) {
                    company.panel = ['0']
                } else {
                    company.panel = []
                }
            },

            selectCrossId(data_id, item, selectedCategory) {
                const company = this.sortedCompaniesList.find(company => company.id === data_id);

                if (company) {
                    if (company.selectedCrossId === item.id) {
                        if (company.is_required_cross) {
                            return;
                        }
                        company.selectedCrossId = null;
                        company.selectedCross = null;
                        company.selectedCategory = '';
                        return;
                    }

                    this.$nextTick(() => {
                        company.selectedCrossId = item.id;
                        company.selectedCross = item;
                        company.selectedCategory = selectedCategory;
                    });
                }
            },

            crossSaleClick(company) {
                if (typeof ym === 'function') {
                    ym(100170943, 'reachGoal', 'sale_click_btn', {
                        order_price: company.selectedCross.price,
                        currency: 'RUB',
                    });
                }
            },

            canShowCross(company) {
                return (
                    (this.waitFetchCross && company.status !== 'error') || company.status === 'waiting' ||
                    company.crosses &&
                    Object.keys(company.crosses).length > 0 &&
                    !this.waitFetchCross &&
                    company.status !== 'error' &&
                    company.status !== 'waiting' &&
                    (company.alias !== 'sk-21-vek' || !company.is_pull)
                )
            },
        },

        computed: {
            formattedKbm() {
                if (this.driversKbms && this.driversKbms.length) {
                    return this.driversKbms.map(driver => {
                        return `${driver.name.trim()} — КБМ ${driver.kbm.toFixed(2)}`;
                    }).join('; ');
                }

                if (this.driversKbmText) {
                    return this.driversKbmText
                        .replace(/Скидка — \d+%/g, '')
                        .replace(/\s{2,}/g, ' ')
                        .replace(/ ,/g, ',')
                        .trim();
                }

                return '';
            },
            commissionGetter() {
                return (company) => {
                    const allowed = ['alpha','rosgosstrah','ingosstrah','soglasie','sk-21-vek'];

                    if (company.is_pull) {
                        if (allowed.includes(company.alias) && company.status === 'ready' && company.payment && company.payment.commission_rub) {
                            return company.payment.commission_rub + ' ₽';
                        }
                        return '-';
                    }

                    return (company.status === 'ready' && company.payment && company.payment.commission_rub)
                        ? Math.round(company.payment.commission_rub) + ' ₽'
                        : '-';
                };
            },
        },
    }
</script>

<style scoped lang="scss">
@keyframes fadeUp {
    from { opacity: 0; transform: translateY(14px); }
    to   { opacity: 1; transform: translateY(0); }
}

.tariff-change-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.tariff-change-button {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: transparent;
    border: 2px solid #00BA57;
    border-radius: 16px;
    padding: 4px 12px;
    cursor: pointer;
    font-size: 14px;
    color: #00BA57;
    font-weight: 500;
    white-space: nowrap;
    transition: background 0.18s, color 0.18s, border-color 0.18s;

    svg {
        width: 11px;
        height: 11px;
        flex-shrink: 0;
        transition: stroke 0.18s;
    }

    &:hover {
        color: #fff;
        background-color: #00BA57;
    }

    &:disabled {
        cursor: default;
        color: #b7b7b7;
        border: 1.5px solid #b7b7b7;

        &:hover {
            color: #b7b7b7;
            background-color: transparent;
        }
    }

    button:focus {
        outline: none;
    }

    button:focus-visible {
        outline: none !important;
    }
}

.tariff-panel {
    position: absolute;
    left: 0;
    top: calc(100% + 10px);
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 12px;
    padding: 16px 16px 14px;
    width: 310px;
    z-index: 100;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08), 0 1px 4px rgba(0, 0, 0, 0.04);
}

.tariff-panel__title {
    font-size: 9px;
    color: #b0b0b0;
    margin: 0 0 14px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    font-weight: 500;
    text-align: center;
}

.tariff-panel__values {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    margin-bottom: 14px;
}

.tariff-panel__manual-input {
    width: 130px;
    text-align: right;
    font-family: 'SFProBold', 'Arial', 'sans-serif';
    font-size: 19px;
    border: none;
    background: transparent;
    padding: 0;
    outline: none;
    transition: color 0.25s ease;
    line-height: 1;
}

.tariff-panel__manual-input::-webkit-outer-spin-button,
.tariff-panel__manual-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

.tariff-panel__currency {
    font-size: 15px;
    font-weight: 400;
    color: #c0c0c0;
    line-height: 1;
    padding-top: 4px;
    transition: color 0.25s ease;
}

.tariff-panel__base {
    text-align: center;
    font-size: 10px;
    color: #b0b0b0;
    margin-bottom: 14px;
}

input[type=range] {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: 4px;
    border-radius: 3px;
    outline: none;
    cursor: pointer;
    border: none;
    transition: background 0.1s;
}

input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #fff;
    border: 1.25px solid #d0d0d0;
    cursor: pointer;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);
    transition: border-color 0.2s, box-shadow 0.2s;
}

input[type=range]::-webkit-slider-thumb:hover {
    border-color: #00BA57;
    box-shadow: 0 2px 10px rgba(0, 186, 87, 0.25);
}

input[type=range]::-moz-range-thumb {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #fff;
    border: 1.25px solid #d0d0d0;
    cursor: pointer;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);
}

input[type=range]::-moz-range-track {
    height: 4px;
    border-radius: 3px;
    background: transparent;
}

.tariff-panel__labels {
    display: flex;
    justify-content: space-between;
    font-size: 9px;
    color: #c8c8c8;
    margin-top: 8px;
    margin-bottom: 12px;
}

.tariff-panel__divider {
    border: none;
    border-top: 1px solid #f0f0f0;
    margin: 0 0 14px;
}

.tariff-recalc-btn {
    display: block;
    width: 100%;
    padding: 7px 0;
    border: none;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    transition: opacity 0.15s, transform 0.1s, background 0.15s, border-color 0.15s, box-shadow 0.15s;
}

.tariff-recalc-btn + .tariff-recalc-btn {
    margin-top: 8px;
}

.tariff-recalc-btn:not(.reject) {
    background: #00BA57;
    border: 1px solid #00A84F;
    box-shadow: 0 0 0 2px rgba(0, 186, 87, 0.12);
    color: #fff;
}

.tariff-recalc-btn:not(.reject):hover {
    opacity: 0.88;
}

.tariff-recalc-btn:not(.reject):active {
    transform: scale(0.98);
}

.tariff-recalc-btn:not(.reject):disabled {
    background: #e0e0e0;
    border-color: #e0e0e0;
    box-shadow: none;
    color: #b0b0b0;
    cursor: default;
}

.tariff-recalc-btn.reject {
    background: transparent;
    color: #b0b0b0;
    border: 1px solid #e8e8e8;
}

.tariff-recalc-btn.reject:not(:disabled):hover {
    background: #fef2f2;
    color: #e53535;
    border-color: #fcc;
}

.tariff-recalc-btn.reject:active {
    transform: scale(0.98);
}

.tariff-recalc-btn.reject:disabled {
    color: #d0d0d0;
    cursor: default;
}

.infoText {
    font-size: 15px;
}

.kbm-text {
    font-size: 13px;
    font-weight: 400;
    white-space: pre-wrap;
}

.color-wrapper {
    display: inline-block;
    padding: 7px 14px;
    background: #F4F4F4;
    border-radius: 7px;
    margin-bottom: 10px;
}

.color-wrapper__title {
    font-family: 'SFProBold', 'SFPro', 'sans-serif';
    font-size: 13px;
}

.result {
    padding: 10px;
    justify-content: space-between;

    border: 1px solid #e9eceb;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
    background: #ffffff;
    border-radius: 14px;

    animation: fadeUp-data-v-2d1b8a4a 1.2s ease both;

    margin-bottom: 20px !important;

    @media (max-width: 600px) {
        padding: 10px 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        border-top: 1px solid rgba(0, 0, 0, 0.2);
        border-left: unset;
        border-right: unset;
        margin-bottom: unset !important;
        border-radius: unset;
    }
}

.result:last-child {
    border-bottom-width: 0;
}

.result__logo-layout {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    font-size: 14px;
}

.logo {
    max-width: 100%;
    width: 170px;
    max-height: 55px;
    object-fit: contain;
    object-position: left;
}

.logo-sm {
    max-width: 170px;
    width: 100%;
}

.data-param {
    font-size: 22px;
    display: block;
    font-family: 'SFProBold', 'SFPro', 'sans-serif';
    /*padding-top: 10px;*/
}

.cross-params {
    border-bottom: 1px solid #e8e8e8;
}

.data-cross-param {
    display: block;
    font-size: 13px;
    font-family: 'SFProBold', 'SFPro', 'sans-serif';
}

.data-title {
    font-size: 13px;
    font-weight: 400;
    color: #828282;
    font-family: 'SFUIDisplay', 'SFPro', 'sans-serif';
}

.data-cross-title {
    font-size: 10px;
    font-weight: 400;
    color: #828282;
    font-family: 'SFUIDisplay', 'SFPro', 'sans-serif';
    white-space: normal;
}

.tooltip {
    position: relative;
    display: inline-block;
    vertical-align: -3px;
    margin-left: 3px;
}

.tooltip .tooltiptext {
    visibility: hidden;
    width: 280px;
    background-color: #f0f0f0;
    text-align: left;
    padding: 7px 10px;
    font-size: 12px;
    bottom: calc(100% + 10px);
    left: 50%;
    margin-left: -140px;
    position: absolute;
    z-index: 1;
}

.tooltip:hover .tooltiptext {
    visibility: visible;
}

.button-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.wrong-label {
    font-family: 'SFUIDisplay', 'Arial', 'sans-serif';
}

.payment-hint {
    font-size: 14px;
}

.payButtonLink {
    color: #ffffff;
    font-size: 15px;
    line-height: 1.55;
    font-weight: 600;
    border-width: 1px;
    border-radius: 100px;
    background-color: #00BA57;
    border-color: transparent;
    text-decoration: none;
    height: 50px;
    padding-top: 15px;
    display: block;
    vertical-align: middle;
    text-align: center;
    width: 100%;
}

.payButton {
    color: #ffffff !important;
    line-height: 1.55 !important;
    font-weight: 400 !important;
    font-size: 15px !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 44px;
    width: 100%;
    background-color: #00ba57 !important;;
    text-align: center;
    display: block;
    vertical-align: middle;
    padding: 0 !important;
    margin: 0;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

.payButton >>> .v-btn__content {
    white-space: normal;
    line-height: 1.1;
}

.loader-wrapper {
    position: relative;
    text-align: end;
}

.btn-loading {
    width: 25px;
    position: relative;
    top: -24px;
    right: 23px;
}

.preloading {
    position: relative;
    z-index: 999;
    height: 1080px;
    width: 100%;
    overflow: visible;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    background: red;
}

.start-action-text {
    font-size: 14px;
}

a.policy {
    font-size: 14px;
    color: #00ba57;
}

a.underline {
    text-decoration: underline
}

.color-black {
    color: black;
    cursor: pointer;
}

.above-button {
    display: block;
    padding: 0 22px 6px;
}

.disabled-link {
    color: #aeaeae;
}

.text-center {
    text-align: center;
}

.start-date-text {
    font-weight: 600;
}

.blink-green {
    -moz-animation: blink-green 2s linear infinite;
    -webkit-animation: blink-green 2s linear infinite;
    animation: blink-green 2s linear infinite;
}
@-moz-keyframes blink-green {
    0% { color: #00ba57; }
    100% { color: black; }
}
@-webkit-keyframes blink-green {
    0% { color: #00ba57; }
    100% { color: black; }
}
@keyframes blink-green {
    0% { color: #00ba57; }
    100% { color: black; }
}

.hidden {
    visibility: hidden;
}

.width-auto {
    width: auto !important;
}

.payButton-loader {
    display: flex;
    width: 100%;
    height: 28px;
    justify-content: center;
}

.payButton-loader .timer {
    margin: 0 10px;
}

.show-cross-btn {
    font-size: 15px;
    font-weight: bold;

    color: #000000;
    border-bottom: 1px solid #000000;

    user-select: none;
}

.arrow-up-down {
    color: #000000;
    font-size: 17px;
    transition: transform .4s ease-in-out;

    user-select: none;
}

.rotate {
    transform: rotate(-180deg);
}

.information-billet__row {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 6px;
}

.information-billet__label {
    font-size: 13px;
    color: #00ba57;
}

@media (max-width: 600px) {
    .show-cross-btn {
        font-size: 12px;
    }
}
</style>

<style>
.tippy-tooltip.default-theme {
    font-size: 0.875rem !important;
    font-weight: 400 !important;
    text-align: center !important;
    background-color: #FFFFFF !important;
}

.tippy-title {
    font-weight: 700 !important;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/CompaniesList.vue